const Comment = {
  'id': 'Comment',
  'layout': {
    'rows': 1,
    'columns': 1
  },
  'fields': [
    {
      'id': '1',
      'type': 'PAPER_CONTAINER',
      'props': {
        'label': 'Sales order comment',
        'name': 'notepad',
        'fullWidth': true
      },
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 3
      },
      'children': [
        {
          'id': '1',
          'type': 'TEXT_AREA',
          'props': {
            'name': 'Comment',
            'fullWidth': true,
            'style': {
              'height': '650px'
            }
          },
        },
      ]
    },
  ]
};
export default Comment;